import { Component, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Http, Headers, RequestOptions, ResponseContentType, URLSearchParams } from '@angular/http';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs/Rx';
import { Router }  from '@angular/router';

@Component({
    selector: 'page-for',
    templateUrl: './for.html',
    styleUrls: ['./for.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ForPage {

	form: FormGroup;
	isSubmit = false;

	constructor (
		private router: Router,
		private _fb: FormBuilder,
		private http: Http
	) {
		this.form = this._fb.group({
			//name: ['', [Validators.required]],
			email: ['', [Validators.required, Validators.email]]
		});
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}

	isValid() {
		return this.form.valid;
	}


	submitForm() {
		var headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded' );
		let options = new RequestOptions({ 
			headers: headers,
			responseType: ResponseContentType.Text 
		});
 
		let postParams = {
			list: 'ZXUny4yiJCjojKqFtK5qpQ',
			...this.form.value
		};
		let sparams = new URLSearchParams();
		for(let key in postParams){
			sparams.set(key, postParams[key]);
		}
		this.isSubmit = true;
		this.http.post('https://e.webstroika.com/subscribe', sparams, options).subscribe(data => {});
	}

}



// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/pages/for/for.ts